// user-dashboard/components/SelfTransferConfirmModal.jsx
import React, { useState } from "react";

/**
 * Confirmation notice before enabling Self TM Transfer.
 *
 * Props:
 * - open, onClose
 * - email: address shown in brackets
 * - onConfirm: () => Promise
 */
export default function SelfTransferConfirmModal({
  open,
  onClose,
  email = "",
  onConfirm,
}) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  if (!open) return null;

  const stop = (e) => e.stopPropagation();
  const displayEmail = (email || "").trim() || "—";

  const handleConfirm = async () => {
    setSubmitting(true);
    setError(null);
    try {
      await onConfirm?.();
      onClose?.();
    } catch (err) {
      setError(err?.response?.data?.detail || err?.message || "Failed to enable Self TM Transfer");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="modal fade show"
      style={{ display: "block", background: "rgba(0,0,0,0.45)" }}
      onClick={onClose}
    >
      <div className="modal-dialog" onClick={stop}>
        <div className="modal-content" style={{ fontSize: "1rem" }}>
          <div className="modal-header">
            <h5 className="modal-title">Enable Self TM Transfer</h5>
            <button type="button" className="btn-close" onClick={onClose} disabled={submitting} />
          </div>
          <div className="modal-body">
            <p className="mb-3">
              By enabling Self TM Transfer, the buyer will be responsible for
              fulfilling this transfer. Please confirm that the buyer accepts
              this responsibility.
            </p>
            <p className="mb-3 fw-semibold">{displayEmail}</p>
            <p className="mb-0">
              Buyer will be solely responsible for completing this TM transfer.
            </p>
            {error && (
              <div className="alert alert-danger py-2 small mt-3 mb-0">{error}</div>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary btn-sm"
              onClick={onClose}
              disabled={submitting}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-danger btn-sm"
              onClick={handleConfirm}
              disabled={submitting}
            >
              {submitting ? "Enabling…" : "Confirm & Enable"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
